import VcIconSvg from '../../control/navigation/icon/VcIconSvg.vue'
import drawIcons from '../drawIcons'
VcIconSvg.register(drawIcons)
